/**
 * Toplist V2 Slider — arrow navigation + touch swipe
 *
 * Translates the track left/right by one card width per click/swipe.
 * Disables prev/next arrows at boundaries.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var wraps = document.querySelectorAll('.toplist-v2--slider-wrap');

    wraps.forEach(function (wrap) {
      var prev = wrap.querySelector('.toplist-v2-slider__arrow--prev');
      var next = wrap.querySelector('.toplist-v2-slider__arrow--next');
      var track = wrap.querySelector('.toplist-v2--slider-track');
      if (!prev || !next || !track) return;

      var cards = track.querySelectorAll('.toplist-v2-card');
      if (cards.length === 0) return;

      var currentIndex = 0;
      var SWIPE_THRESHOLD = 50;

      function getCardWidth() {
        var card = cards[0];
        var style = window.getComputedStyle(card);
        return card.offsetWidth + parseInt(style.marginRight || 0, 10);
      }

      function getVisibleCards() {
        var slider = wrap.querySelector('.toplist-v2--slider');
        if (!slider) return 1;
        var cardW = getCardWidth();
        var gap = parseInt(window.getComputedStyle(track).gap || 0, 10);
        return Math.floor(slider.offsetWidth / (cardW + gap)) || 1;
      }

      function getMaxIndex() {
        var visible = getVisibleCards();
        return Math.max(0, cards.length - visible);
      }

      function goTo(index) {
        currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        var cardW = getCardWidth();
        var gap = parseInt(window.getComputedStyle(track).gap || 0, 10);
        var offset = currentIndex * (cardW + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';

        prev.disabled = currentIndex <= 0;
        next.disabled = currentIndex >= getMaxIndex();
      }

      // Arrow clicks
      prev.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });

      next.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });

      // Touch swipe
      var startX = 0;
      var startY = 0;
      var isDragging = false;

      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!isDragging) return;
        var diffX = Math.abs(e.touches[0].clientX - startX);
        var diffY = Math.abs(e.touches[0].clientY - startY);
        // If horizontal swipe is dominant, prevent vertical scroll
        if (diffX > diffY && diffX > 10) {
          e.preventDefault();
        }
      }, { passive: false });

      track.addEventListener('touchend', function (e) {
        if (!isDragging) return;
        isDragging = false;

        var endX = e.changedTouches[0].clientX;
        var diffX = startX - endX;

        if (Math.abs(diffX) < SWIPE_THRESHOLD) return;

        if (diffX > 0) {
          // Swipe left → next
          goTo(currentIndex + 1);
        } else {
          // Swipe right → prev
          goTo(currentIndex - 1);
        }
      });

      // Resize
      window.addEventListener('resize', function () {
        goTo(currentIndex);
      });

      // Initial state
      goTo(0);
    });
  });
})();
